<template lang="pug">
v-container
  v-row
    v-col(cols="12")
      h1 Группы Обращений
    v-col(cols="12")
      v-btn.mb-4(color="success" @click="openDialogForm") Добавить группу
        v-icon(right) mdi-plus
      v-card.pa-4.mb-5(outlined)
        v-expansion-panels(v-model="panel")
          v-expansion-panel(
            outlined
            v-for="(group, index) in groups"
            :key="group.id"
          )
            v-expansion-panel-header(v-slot="{ open }").title {{ group.title }}
            v-expansion-panel-content
              smart-table(
                :key="panel ? panel : 1"
                v-model="selected"
                :adapter="adapter"
                :headers="headers"
                :needToUpdateTable="needToUpdateTable"
                show-select
              )
                template(#value--todo_lists_status="{ item }")
                  .d-flex.align-center.flex-column.mt-2(
                    v-if="item.todo_lists_status && item.status !== CLIENT_QUESTION_STATUS.PENDING && item.todo_lists_status.total"
                  )
                    v-progress-circular(
                      :size="30"
                      :width="7"
                      :value="item.todo_lists_status.complete / item.todo_lists_status.total * 100"
                      color="accent"
                    )
                    span {{ item.todo_lists_status.complete }} из {{ item.todo_lists_status.total }}
                  .d-flex.align-center.flex-column.mt-2(v-else) -

                template(#value--project_id="{ item }")
                  v-chip(
                    small
                    color="secondary"
                    label
                  ) {{ cachedProject(item.project_id).name }}
                template(#value--municipality_id="{ item }")
                  v-chip(v-if="item.municipality_id" text label small)
                    | {{ cachedMunicipality(item.municipality_id).name }}
                template(#value--view="{ item }")
                  router-link(:to="`/application/${item.id}`")
                    v-icon(color="primary" small) mdi-eye
                template(#value--status="{ item }")

                  v-chip(small label :color="statusColor(item.status)")
                    template(v-if="isConsultating(item)") Ожидает консультации
                    template(v-else) {{ CLIENT_QUESTION_STATUS_TEXT[item.status] }}
              v-btn.rounded.mt-2(
                color="success"
                fab
                x-small
                @click="openDialog(group.id)"
              )
                v-icon mdi-plus
              v-btn.rounded.mt-2.ml-2(
                color="error"
                fab
                x-small
                v-if="selected.length > 0"
                @click="detachApp(group.id)"
              )
                v-icon mdi-trash-can
              v-btn.rounded.mt-2.ml-2(
                color="error"
                @click="deleteGroup(group.id)"
                small
              ) удалить группу

  select-treatment(
    v-model="dialogTreatment"
    :group="groups[panel]"
    @close="closeDialog"
    @success="acceptChanges"
  )
  group-modal-form(
    :value="dialogEventForm"
    @close="closeEventForm"
  )
</template>

<script>
import { CLIENT_QUESTION_STATUS, CLIENT_QUESTION_STATUS_TEXT } from '../../constants';
import { mapActions, mapGetters } from 'vuex';
import { CACHE_KEYS } from '@/store/modules/cache';
import GroupModalForm from './components/GroupModalForm.vue';
import SelectTreatment from './components/SelectTreatment.vue';
import clientQuestionService from '@/services/API/client-questions';
import SmartTable from '@/components/SmartTable/index.vue';
import groupServices, { CRUDGroups } from '@/services/API/client-question-groups';

export default {
  components: {
    SmartTable,
    GroupModalForm,
    SelectTreatment,
  },
  data() {
    return {
      dialogTreatment: false,
      dialogEventForm: false,
      selectedID: null,
      groups: [],
      data: false,
      selected: [],
      panel: 0,
      CLIENT_QUESTION_STATUS,
      CLIENT_QUESTION_STATUS_TEXT,
      headers: [
        {
          text: '',
          value: 'view',
        },
        {
          text: 'Номер заявки',
          value: 'id',
          sortable: true,
          searchable: true,
        },
        {
          text: 'Название проблемы',
          value: 'text',
          sortable: true,
          searchable: true,
        },
        {
          text: 'Дата заявки',
          value: 'created_at',
          sortable: true,
        },
        {
          text: 'Статус',
          sortable: true,
          value: 'status',
        },
        // {
        //   text: 'Процесс выполнения',
        //   sortable: true,
        //   value: 'todo_lists_status',
        //   align:'center',
        // },
        {
          text: 'Почта отправителя',
          sortable: true,
          value: 'email',
          searchable: true,
        },
        { text: 'Муниципалитет', value: 'municipality_id', sortable: true },
        // { text: 'Роль пользователя', value: 'role',          sortable:true },
        // { text: 'Регион', value: 'region',          sortable:true },
        { text: 'Проект', value: 'project_id', sortable: true },
        // { text: 'Тип проблемы', value: 'type_problem',          sortable:true },
      ],
    };
  },
  computed:{
    ...mapGetters({
      'cachedMunicipality':'cache/cachedMunicipality',
      'cachedProject':'cache/cachedProject',
      'notification':'notification/notification',
      'user':'auth/getUser',
    }),

    statusItems() {
      return Object.keys(CLIENT_QUESTION_STATUS_TEXT).map((key) => ({
        value: key,
        text: CLIENT_QUESTION_STATUS_TEXT[key],
      }));
    },
  },
  methods: {
    ...mapActions({
      'loadToCache':'cache/loadToCache',
    }),
    statusColor(status) {
      return {
        [CLIENT_QUESTION_STATUS.PENDING]: 'error',
        [CLIENT_QUESTION_STATUS.ACCEPTED]: 'primary',
        [CLIENT_QUESTION_STATUS.ANSWERED]: 'success',
        [CLIENT_QUESTION_STATUS.CLOSED]: 'secondary',
        [CLIENT_QUESTION_STATUS.AWAITING]: 'accent',
      }[status];
    },
    isConsultating({ status, current_transfer }) {
      return status === CLIENT_QUESTION_STATUS.AWAITING && current_transfer?.owner_id === this.user.id;
    },
    async detachApp(id) {
      try {
        await groupServices.detach(id, { 'client_question_ids': this.selected });
        this.needToUpdateTable = true;
        await this.fetchGroups();
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    openDialog(id) {
      this.dialogTreatment = true;
      this.selectedID = id;
    },
    async closeEventForm() {
      this.dialogEventForm = false;
      await this.fetchGroups();
    },
    openDialogForm(group) {
      if (group) {
        this.data = group;
      }
      this.dialogEventForm = true;
    },
    closeDialog() {
      this.dialogTreatment = false;
      this.selectedID = null;
    },
    async fetchGroups() {
      try {
        const response = await CRUDGroups.getAll({ 'expand': 'client_questions' });
        this.groups = response.data.data;
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async acceptChanges() {
      this.needToUpdateTable = true;
      await this.fetchGroups();
    },
    async attachGroup(id) {
      try {
        const params = {
          'client_question_ids': [1],
        };
        await groupServices.attach(id, params);
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async deleteGroup(id) {
      try {
        await CRUDGroups.delete(id);
        await this.fetchGroups();
      } catch (e) {
        this.$toast.error(e.response.data.result_message);
      }
    },
    async adapter({ _update, ...options }) {
      const params = {
        'sort': '-id',
        'search[group_id]': this.groups[this.panel].id,
        'expand': 'todo_lists_status,current_transfer',
        ...options,
      };
      this.needToUpdateTable = false;
      this.updateTable = _update;
      const response = await clientQuestionService.getAll(params);

      const municipality_ids = response.data.data.map(({ municipality_id }) => municipality_id);
      await this.loadToCache({ key: CACHE_KEYS.municipalities, ids: municipality_ids });

      const project_ids = response.data.data.map(({ project_id }) => project_id);
      await this.loadToCache({ key: CACHE_KEYS.projects, ids:  project_ids });

      return new Promise((resolve) => resolve(response));
    },
  },
  watch: {
    panel: {
      handler() {
        this.selected = [];
      },
    },
  },
  created() {
    this.fetchGroups();
  },
};
</script>

<style scoped>

</style>
